const profile = {
  title: "我的主頁",
  premiumBtn: "成為會員",
  orderInfoTitle: "帳號許可權資訊",
  tableProduct: "產品",
  tableStatus: "狀態",
  tablePermissionDate: "許可權日期",
  tableValidPeriod: "有效期",
  validStauts: "生效中",
  expiredStauts: "已過期",
  noData: "無數據",
};

export default profile;
